import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';
import { doctorsData } from '../lib/data';
import styles from './Doctors.module.scss';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';



gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 


const Doctors = () => {
    useGSAP(() => {
        gsap.to(".title__team", { "--opacity": 1, "--x": "0px",
                                    y:-10,  
                                    duration: 1, 
                                    scrollTrigger: {
                                        trigger: ".title__team"
        }});
        gsap.fromTo(".team__card", {opacity: 0, }, 
                                   {opacity: 1,
                                    duration: 3, 
                                    stagger:1,
                                    delay:1,
                                    scrollTrigger: {
                                    trigger: ".team__card"
        }});
    }, [])
    return ( 
        <section >     
            <Stack      
                justifyContent = 'justifyCenter'                    
            >
                <Text type="h2" size='xl' className={`title__team ${styles.title}`}>
                    НАШИ УСЛУГИ
                </Text>    
            </Stack>
            <div className={styles.dark}>
                <div className={styles.team__card}>
                    {doctorsData.map(element => 
                    <div
                        className={`team__card ${styles.team}`}
                        key={element.id}>
                            <div  className={styles.content}>
                                <div className={styles.photo__container}>
                                    <img className={styles.photo} src={element.img} alt='Верюжский Андрей Александрович'/>
                                </div>

                                <Stack 
                                        direction = 'column'   
                                        gap = '8'                     
                                        alignItems = 'alignCenter'
                                        className={styles.team__text}>  
                                    <Text size='m' className={styles.team__title}>
                                        {element.title}
                                    </Text>
                                    <Text size='s' className={styles.description}>
                                        {element.speciality}
                                    </Text>                                                 
                                </Stack>                       
                            </div>
                    </div>
                )}
                </div>
    
            </div>
        </section>
     );
}
 
export default Doctors;